var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D8D8D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8062_106003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5593 18.9414C23.3986 18.9414 23.2444 19.0065 23.1308 19.1223C23.0171 19.2381 22.9532 19.3952 22.9532 19.5591V22.1612C22.9528 22.6176 22.7746 23.0551 22.458 23.3779C22.1413 23.7006 21.712 23.8821 21.2642 23.8826H13.7332C13.2854 23.8821 12.8561 23.7006 12.5394 23.3779C12.2227 23.0551 12.0446 22.6176 12.0442 22.1612V19.5591C12.0442 19.3952 11.9803 19.2381 11.8666 19.1223C11.753 19.0065 11.5988 18.9414 11.4381 18.9414C11.2774 18.9414 11.1232 19.0065 11.0095 19.1223C10.8959 19.2381 10.832 19.3952 10.832 19.5591V22.1612C10.8328 22.9451 11.1388 23.6967 11.6827 24.251C12.2266 24.8053 12.964 25.1171 13.7332 25.1179H21.2642C22.0334 25.1171 22.7708 24.8053 23.3147 24.251C23.8586 23.6967 24.1646 22.9451 24.1654 22.1612V19.5591C24.1654 19.3952 24.1015 19.2381 23.9879 19.1223C23.8742 19.0065 23.72 18.9414 23.5593 18.9414Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4436 16.6825L17.2595 14.0086V21.8477C17.2595 22.0129 17.3286 22.1713 17.4516 22.2881C17.5746 22.4049 17.7414 22.4706 17.9154 22.4706C18.0893 22.4706 18.2562 22.4049 18.3792 22.2881C18.5022 22.1713 18.5713 22.0129 18.5713 21.8477V14.0086L21.3871 16.6825C21.5108 16.7959 21.6765 16.8587 21.8485 16.8573C22.0205 16.8559 22.185 16.7904 22.3066 16.6749C22.4282 16.5594 22.4972 16.4032 22.4987 16.2399C22.5002 16.0766 22.4341 15.9192 22.3146 15.8018L18.3791 12.0647C18.2561 11.9479 18.0893 11.8823 17.9154 11.8823C17.7414 11.8823 17.5746 11.9479 17.4516 12.0647L13.5162 15.8018C13.3967 15.9192 13.3306 16.0766 13.3321 16.2399C13.3336 16.4032 13.4025 16.5594 13.5241 16.6749C13.6458 16.7904 13.8103 16.8559 13.9822 16.8573C14.1542 16.8587 14.3199 16.7959 14.4436 16.6825Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8062_106003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(10 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcd);
export default __webpack_public_path__ + "static/media/Upload_icd.7c1038b06dafbb7dec68b977fd3bdc62.svg";
export { ForwardRef as ReactComponent };